import { render, staticRenderFns } from "./Giropay.vue?vue&type=template&id=342f17eb&scoped=true"
import script from "./Giropay.vue?vue&type=script&lang=js"
export * from "./Giropay.vue?vue&type=script&lang=js"
import style0 from "./Giropay.vue?vue&type=style&index=0&id=342f17eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f17eb",
  null
  
)

export default component.exports